import React, { useEffect, useState } from "react";
import { IComponentProps } from "../../common/utils/commonTypes";
import webui from "@tinqin/tinqin-web-ui";

//On focus out of specified elements the target elements are hidden (some of the focus out elements are in different parts of the dom)
const FocusOutContainer: React.FC<IComponentProps> = props => {
    const [isMouseDownInFocusedOutElement, setIsMouseDownInFocusedOutElement] = useState(false);
    const {
        focusOutProperties
    }: {
        focusOutProperties: { focusOutElements: [string]; targets: [string] };
    } = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["focusOutProperties"],
        propsDefaults: {
            focusOutProperties: false
        }
    });

    useEffect(() => {
        //In case the user select text in the input and after that 
        //release the button outside the focusOutContainer we do not want to hide it
        const onMouseDown = ({ target }: MouseEvent) => {
            for (const targetElement of focusOutProperties.targets) {
                const mouseDownElement = document.querySelector<HTMLElement>(`.${targetElement}`);
                const mouseDownContainsTarget = mouseDownElement.contains(target as Node);
                setIsMouseDownInFocusedOutElement(mouseDownContainsTarget);
                if (mouseDownContainsTarget) break;
              }
        };
        document.addEventListener("mousedown", onMouseDown);
        return () => document.removeEventListener("mousedown", onMouseDown);
    }, [focusOutProperties]);

    useEffect(() => {
        if (focusOutProperties) {
            const onClick = ({ target }: MouseEvent) => {
                if (isMouseDownInFocusedOutElement) return;
                let isFocusedOut = true;
                focusOutProperties.focusOutElements.forEach(focusedOutElement => {
                    const element = document.getElementsByClassName(focusedOutElement).item(0);
                    if (element.contains(target as Node)) {
                        isFocusedOut = false;
                    }
                });
                if (isFocusedOut) {
                    focusOutProperties.targets.forEach(targetElement => {
                        const elementToHide = document.querySelector<HTMLElement>(
                            `.${targetElement}`
                        );
                        if (elementToHide.style.display !== "none") {
                            elementToHide.style.display = "none";
                        }
                    });
                }
            };
            document.addEventListener("click", onClick);
            return () => document.removeEventListener("click", onClick);
        }
    }, [focusOutProperties, isMouseDownInFocusedOutElement]);

    if (!props.data) {
        return webui.getUtils().getEmptyContent();
    }

    return <>{webui.getUtils().resolveChildren(props)}</>;
};

export default webui.connectComponent()(FocusOutContainer);
